import { forwardRef, RefObject } from "react";
import { Button } from "src/components";
import FilterAccordion from "src/features/fields/container/FilterAccordion";

interface FilterItem {
  id?: string;
  name?: string;
  code?: string | number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

interface StockistMappingFiltersProps {
  onClose: () => void;
  companyDetails: FilterItem[];
  stockistDetails: FilterItem[];
  selectedCompany: FilterItem[];
  selectedStockist: FilterItem[];
  onCompanyChange: (details: FilterItem[]) => void;
  onStockistChange: (details: FilterItem[]) => void;
  onReset: () => void;
}

const Divider = () => <div className="w-full h-[0.0625rem] my-2 bg-[#0000001a]" />;

const StockistMappingFiltersComponent = forwardRef<HTMLElement, StockistMappingFiltersProps>(
  ({ onClose, companyDetails, stockistDetails, selectedCompany, selectedStockist, onCompanyChange, onStockistChange, onReset }, ref) => {
    return (
      <aside
        ref={ref as RefObject<HTMLElement>}
        className="bg-white border-l-[1px] min-w-[24rem] overflow-y-auto max-w-[25rem] border-l-[#00000014] fixed px-8 text-[#49484C] text-xl font-semibold py-5 right-0 h-screen"
      >
        <div className="flex items-center justify-between gap-5 mt-3">
          <h3 className="whitespace-nowrap">Filters</h3>
          <Button className="border py-1 bg-[#7F56D9] text-white" onClick={onReset}>
            Reset
          </Button>
          <Button className="border py-2 bg-[#7F56D9] text-white" onClick={onClose}>
            Close
          </Button>
        </div>

        <div className="flex flex-col pt-4">
          <FilterAccordion
            uniqueKey="code"
            displayKey="shortname"
            onSelectingFilter={onCompanyChange}
            title="Company Name"
            arrayToFilter={companyDetails}
            defaultValue={selectedCompany}
            isSingleSelect={true}
          />
          <Divider />
          <FilterAccordion
            uniqueKey="stockist_id"
            displayKey="stockist_display"
            onSelectingFilter={onStockistChange}
            title="Stockist"
            arrayToFilter={stockistDetails}
            defaultValue={selectedStockist}
            isSingleSelect={true}
          />
        </div>
      </aside>
    );
  }
);

export default StockistMappingFiltersComponent;
